import { Helmet } from "react-helmet-async";
import { useLang, tr } from "../../lib/i18n";

export default function SEO({ seoData, fallbackTitle = "Sarita's Photography" }) {
  const lang = useLang();
  if (!seoData) {
    return (
      <Helmet>
        <html lang={lang} />
        <title>{fallbackTitle}</title>
      </Helmet>
    );
  }
  const title = tr(seoData.title, lang) || fallbackTitle;
  const description = tr(seoData.description, lang) || "";
  const ogImage = seoData.og_image || "";

  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      {ogImage && <meta property="og:image" content={ogImage} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {ogImage && <meta name="twitter:image" content={ogImage} />}
    </Helmet>
  );
}
